import { useGet } from '../../HttpClient';
import { AccountStatusDefinitionModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useQueryClient } from '@tanstack/react-query';
import { useQueryWithErrorHandling } from '../../../hooks/UseQueryWithErrorHandling';

const pillarCode = "tms";
const getASDQueryKey = "get-account-status-definitions";

export function useAccountStatusDefinitions() {
  const get = useGet(true, pillarCode);
  const getAccountStatusDefinitions = (): Promise<AccountStatusDefinitionModel[]> =>
      get(`${referenceDataBaseUrl}/account-status-definitions`);
  return useQueryWithErrorHandling({
    queryKey: [getASDQueryKey],
    queryFn: async () => await getAccountStatusDefinitions(),
  });
}

export function useRefreshAccountStatusDefinitions() {
  const queryClient = useQueryClient();

  return async () => await queryClient.invalidateQueries({ queryKey: [getASDQueryKey] });
}
